import { Box } from '@mui/system';
import styled from 'styled-components';
import { AccordionDetails, AccordionSummary } from '@mui/material';

export const ModalWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CloseModalWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  width: 100%;
`;

export const ExportReportWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 32px;
  background-color: ${({ theme }) => theme.palette.base.background};
  box-shadow: ${({ theme }) => theme.shadows[31]};
  border-radius: 12px;
`;

export const MainExportContent = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
`;

export const SwitchWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
`;

export const FooterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
`;

export const ButtonWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
`;

export const AccordionSummaryExport = styled(AccordionSummary)`
  width: 100%;
  border: none;
  padding: 0 !important;
  margin: 0 !important;
  min-height: unset !important;
  height: 28px !important;
  background-color: ${({ theme }) => theme.palette.base.background};

  .Mui-expanded {
    margin: 0;
  }
`;

export const AccordionDetailsExport = styled(AccordionDetails)`
  padding: 0;
  background-color: ${({ theme }) => theme.palette.base.background};
`;
